import { render } from "./Customers.vue?vue&type=template&id=4f015b31&scoped=true"
import script from "./Customers.vue?vue&type=script&lang=js"
export * from "./Customers.vue?vue&type=script&lang=js"

import "./Customers.vue?vue&type=style&index=0&id=4f015b31&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f015b31"],['__file',"src/views/Customers/Customers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f015b31"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f015b31', __exports__)) {
    api.reload('4f015b31', __exports__)
  }
  
  module.hot.accept("./Customers.vue?vue&type=template&id=4f015b31&scoped=true", () => {
    api.rerender('4f015b31', render)
  })

}


export default __exports__